import React from "react";
import BasicButton from "./BasicButton";

/**
 * Drop down selection UI component
 * @param header            title for drop down - for example <h3> title </h3>
 * @param children          child elements to choose from
 * @param initiallyOpen     If accordion is opened when created
 * @param dynamicOpen       To open by a parent after created depending on content
 * @returns {JSX.Element}
 * @constructor
 */
export default function AccordionDropdown({header, children, initiallyOpen, dynamicOpen, callback, closeable}) {
    const [open, setOpen] = React.useState(initiallyOpen || dynamicOpen || false)
    //const [style, setStyle] = React.useState(null)
    //const [contentRef] = useHookWithRefCallback()

    // function useHookWithRefCallback() {
    //     const ref = useRef(null)
    //     const setRef = useCallback(node => {
    //         if(node) {
    //             const thisHeight = node.offsetHeight//node.offsetHeight
    //             setStyle({
    //                 height: thisHeight + 'px'
    //             })
    //         }
    //         ref.current = node
    //     }, [])
    //     return [setRef]
    // }

    function fireCallback(_open){
        if(typeof callback === 'function' && !initiallyOpen) callback(_open)
    }

    function toggleAccordion(evt){
        evt.stopPropagation()
        setOpen(dynamicOpen || !open)
        fireCallback(!open)
    }

    function renderCloseButton(){
        return <div className={"btn-set"}>
            <BasicButton
                title={open ? "Sulje" : "Avaa"}
                action={toggleAccordion}
                icon={"chevron-" + (open ? "up btn-state-selected" : "down")
                + (typeof closeable !== 'undefined' && !closeable  ? " not-visible" : "")}
            />
        </div>
    }

    return <div
            className={"accordion-dropdown" + (open ? " open" : "")}
        >
            <header
                    onClick={toggleAccordion}
                >
                <div>{header}</div>
                {renderCloseButton()}
            </header>
            {open ? <section
                    //ref={contentRef}
                    //style={style}
                >{children}</section> : null}
    </div>
}